export const defaultErrorMessage =
  "Something went wrong, please try again soon.";
